import { render, staticRenderFns } from "./CardLogo.vue?vue&type=template&id=55e21674"
import script from "./CardLogo.vue?vue&type=script&lang=js"
export * from "./CardLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports